import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";

export const suppliesApi = createApi({
  reducerPath: "suppliesApi",
  baseQuery,
  endpoints: (builder) => ({
    getGroups: builder.query({
      query: () => "supplies",
    }),
    register: builder.mutation({
      query: (form) => ({
        url: "supplies",
        method: "POST",
        body: form,
      }),
    }),
    update: builder.mutation({
      query: ({ id, formData }) => ({
        url: `supplies/${id}`,
        method: "PUT",
        body: formData,
      }),
    }),
  }),
});

export const { useGetSuppliesQuery, useRegisterMutation, useUpdateMutation } =
suppliesApi;
